

//body scroll lock https://www.npmjs.com/package/body-scroll-lock
!function (e, o) { if ("function" == typeof define && define.amd) define(["exports"], o); else if ("undefined" != typeof exports) o(exports); else { var t = {}; o(t), e.bodyScrollLock = t } }(this, function (exports) { "use strict"; Object.defineProperty(exports, "__esModule", { value: !0 }); var t = !1; if ("undefined" != typeof window) { var e = { get passive() { t = !0 } }; window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e) } function l(o) { return c.some(function (e) { return !(!e.options.allowTouchMove || !e.options.allowTouchMove(o)) }) } function d(e) { var o = e || window.event; return !!l(o.target) || (1 < o.touches.length || (o.preventDefault && o.preventDefault(), !1)) } function n() { void 0 !== v && (document.body.style.paddingRight = v, v = void 0), void 0 !== s && (document.body.style.overflow = s, s = void 0) } var i = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && 1 < window.navigator.maxTouchPoints), c = [], a = !1, u = -1, s = void 0, v = void 0; exports.disableBodyScroll = function (r, e) { if (r) { if (!c.some(function (e) { return e.targetElement === r })) { var o = { targetElement: r, options: e || {} }; c = [].concat(function (e) { if (Array.isArray(e)) { for (var o = 0, t = Array(e.length); o < e.length; o++)t[o] = e[o]; return t } return Array.from(e) }(c), [o]), i ? (r.ontouchstart = function (e) { 1 === e.targetTouches.length && (u = e.targetTouches[0].clientY) }, r.ontouchmove = function (e) { var o, t, n, i; 1 === e.targetTouches.length && (t = r, i = (o = e).targetTouches[0].clientY - u, l(o.target) || (t && 0 === t.scrollTop && 0 < i || (n = t) && n.scrollHeight - n.scrollTop <= n.clientHeight && i < 0 ? d(o) : o.stopPropagation())) }, a || (document.addEventListener("touchmove", d, t ? { passive: !1 } : void 0), a = !0)) : function (e) { if (void 0 === v) { var o = !!e && !0 === e.reserveScrollBarGap, t = window.innerWidth - document.documentElement.clientWidth; o && 0 < t && (v = document.body.style.paddingRight, document.body.style.paddingRight = t + "px") } void 0 === s && (s = document.body.style.overflow, document.body.style.overflow = "hidden") }(e) } } else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.") }, exports.clearAllBodyScrollLocks = function () { i ? (c.forEach(function (e) { e.targetElement.ontouchstart = null, e.targetElement.ontouchmove = null }), a && (document.removeEventListener("touchmove", d, t ? { passive: !1 } : void 0), a = !1), u = -1) : n(), c = [] }, exports.enableBodyScroll = function (o) { o ? (c = c.filter(function (e) { return e.targetElement !== o }), i ? (o.ontouchstart = null, o.ontouchmove = null, a && 0 === c.length && (document.removeEventListener("touchmove", d, t ? { passive: !1 } : void 0), a = !1)) : c.length || n()) : console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.") } });

/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */


var mobileMenuDrawer = document.querySelector('#mc_menu');



$(document).ready(function () {

  if (!$('body').hasClass('mobile_opened')) {
    // console.log("resultsboxMamburgerENTRY");
    var resultsboxMamburger = $('.results-box-hamburger');
    // console.log("resultsboxMamburger", resultsboxMamburger);
    /*  resultsboxMamburger.style.display = "none"; */
    $('.results-box-hamburger').css('display', 'none');
  }


  $('.mc_menu_mobile .mc_hamburger').click(function () {

    this.classList.toggle('opened');
    $('body').toggleClass('mobile_opened');
    resetMobile();
    if ($('body').hasClass('mobile_opened')) {
      $('#mc_menu').addClass('mc_solid');
      bodyScrollLock.disableBodyScroll(mobileMenuDrawer, {
        allowTouchMove: function(el) {
          while (el && el !== document.body) {
            if (
              el.classList.contains('mc_list_column') ||
              el.classList.contains('mc_list_links') ||
              el.classList.contains('mc_list_container')
            ) {
              return true;
            }
            el = el.parentElement;
          }
          return false;
        }
      });
    } else {
      bodyScrollLock.clearAllBodyScrollLocks();
      if (!$('body').hasClass('mc_fixed')) {

        $('#mc_menu').removeClass('mc_solid');
      }
    }

    this.setAttribute('aria-expanded', this.classList.contains('opened'));

  });

  $('.mc_menu_mobile .mc_hamburger_sticky').click(function () {

    this.classList.toggle('opened');
    $('body').toggleClass('mobile_opened');
    resetMobile();
    if ($('body').hasClass('mobile_opened')) {
      $('#mc_menu').addClass('mc_solid');
      $('.mc_search_sticky').css("pointer-events", "none");
      $('.mc_search_field_hamburger').removeClass('mc_mobile_search_input_sticky_hide');
      bodyScrollLock.disableBodyScroll(mobileMenuDrawer, {
        allowTouchMove: function(el) {
          while (el && el !== document.body) {
            if (
              el.classList.contains('mc_list_column') ||
              el.classList.contains('mc_list_links') ||
              el.classList.contains('mc_list_container')
            ) {
              return true;
            }
            el = el.parentElement;
          }
          return false;
        }
      });
    } else {
      $('.mc_search_sticky').removeAttr("style");
      bodyScrollLock.clearAllBodyScrollLocks();
      if ($(mc_search_sticky).css('height') == '0px') {
        $('#mc_menu').removeClass('mc_solid');
      }
    }
    $('.results_box_mobile_hamburger').removeClass('results_box_mobile_height_open');

    this.setAttribute('aria-expanded', this.classList.contains('opened'));

    /*  $('body').removeClass('body-overflowy'); */

    if ($('.mobile_opened').length > 0) {

      /*    $('.mc_search_field').removeClass('mc_mobile_search_input_sticky_hide'); */
      $('.mc_search_field_hamburger').removeClass('mc_mobile_search_input_sticky_hide');

    }

  });


  var mc_search_sticky = document.getElementsByClassName('mc_mobile_sticky');
  // matchMedia 768px, add class "mc_solid" 
  var mMediaSticky = window.matchMedia("(max-width: 1200px)");
  var mMediaDesktop = window.matchMedia("(min-width: 1200px)");
  let mc_search_stickyHidden = document.querySelector('div.mc_mobile_sticky');

  if (mMediaSticky.matches) {
    if(!$( "body" ).hasClass( "hidden-searchBar" )){
    $('#mc_menu').addClass("mc_solid");
    }
    $('.new-nav-top-padding-shogun').css('margin-top', '50px');
    $('.new-nav-top-padding').css('margin-top', '30px');
    $('.new-nav-top-padding-discount').css('margin-top', '0px');
    $('.new-nav-top-padding-index').css('margin-top', '50px');
    $('.product-template .new-nav-top-padding').css('margin-top', '0px');
    $('.mc_search').css('display', 'none');
    $('.mc_hamburger').css('display', 'none');
  }


  //Open Dropdowns on Desktop Nav Hover
  //Creates necessary SlickSliders
  $('#mc_menu_top [data-handle]').mouseenter(function () {
    if ($('.mc_list_container[data-handle="search"]').show().data('open') == false || $('.mc_list_container[data-handle="search"]').show().data('open') == "false") {
      $('#mc_menu').addClass('mc_solid');
      $('.mc_list_top').removeClass('open');
      $('.mc_list_container[data-handle="search"]').show().data('open', 'false');
      $(this).addClass('open');
      $('.mc_list_container[data-handle]').hide();
      $('.mc_list_container[data-handle="' + $(this).data('handle') + '"]').show();
      if ($('.mc_list_container[data-handle="' + $(this).data('handle') + '"]').data("slider") == true) {
        $('.mc_list_container[data-handle="' + $(this).data('handle') + '"] .mc_list_columns .slider-container').slick({
          dots: false,
          arrows: true,
          autoplay: false,
          slidesToShow: 4,
          slidesToScroll: 4,
          slide: ".mc_feature_column"
        });
      }
    }
  });

  // Reset Desktop Nav Dropdowns on Mouseout
  // Destroys any created sliders
  $('#mc_menu').mouseleave(function () {
    if ($('.mc_list_container[data-handle="search"]').show().data('open') == false || $('.mc_list_container[data-handle="search"]').show().data('open') == "false") {
      if (screen.width > 768) {
        $('#mc_menu').removeClass('mc_solid');
      }
      $('.mc_list_top').removeClass('open');
      $('.mc_list_container[data-handle]').hide();
      $('.mc_list_container[data-slider] .slick-slider').slick('unslick');
    }
  });


  //Trigger Desktop Nav Search Feature
  $('button.mc_search').click(function () {
    $('.mc_list_top').removeClass('open');
    $('.mc_list_container[data-handle]').hide();
    $('.mc_list_container[data-slider] .slick-slider').slick('unslick');
    $('#mc_menu').addClass('mc_solid');
    $('.mc_list_container[data-handle="search"]').show().data('open', 'true');
    $('.mc_search_field').focus();
    $('.mc_search_field_hamburger').focus();
  });

  var lastScrollTop = 0, delta = 5;

  var scrollTop = window.scrollY;
  // console.log("scrollTop", scrollTop);

  $('.mc_search_close_mobile_scroll').click(function (e) {
    e.preventDefault();
    if (scrollTop < 30) {

      $('#mc_menu').removeClass('mc_solid');

    }
  });


  $(document).ready(function () {
    $('body').css("padding-bottom", "0px !important");
  });

  $(window).scroll(function () {

    let mc_search_stickyHiddenScroll = document.querySelector('div.mc_mobile_sticky');
    var scroll = $(window).scrollTop();
    var fixed = false;
    var mMediaStickyScroll = window.matchMedia("(max-width: 1200px)");
    var mMediaDesktopscroll = window.matchMedia("(min-width: 1200px)");

    //closeNav(); // this may be too aggressive but prevents the menu from staying up while we scroll

    if (scroll >= 30) {
      $('body').addClass('mc_fixed');

    }

    if (scroll < 30) {
      $('.mc_search_close_mobile_scroll').click(function (e) {
        e.preventDefault();
        $('#mc_menu').removeClass('mc_solid');
      });

    }

    if (scroll < 30) {
      if (mMediaDesktopscroll.matches) {

        $('body').removeClass('mc_fixed');
      }
      /*  $('.mc_menu_mobile .mc_search_sticky_scroll').click(function (e) {
         console.log("mc_search_sticky_scroll");
         e.preventDefault();
         if (mMediaStickyScroll.matches && $(mc_search_stickyHidden).outerHeight() == 0) {
           console.log("ELSE NAV 2");
           $('body').removeClass('mc_fixed');
         }
       }); */
    }

    /*
    if (scroll >= 30) {

      // this condition so we stop trying to "keep showing" the mini menu once it's already shown and we've hidden the announcement bar
      if (!fixed) {
        $('.home-top-carousel').slick(`slickPause`);
        var nowScrollTop = $(this).scrollTop();
        var resultBoxOpen = $('.results_box_mobile_height_open');
        if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
          if (!resultBoxOpen.length > 0) {
              //console.log("lastScrollTop", lastScrollTop);
             
            if(!$( "body" ).hasClass( "hidden-searchBar" )){
              if(lastScrollTop <= 200) {
                $('.mc_mobile_sticky').removeClass('mc_mobile_sticky_hide');
                $('.mc_search_box').removeClass('mc_mobile_sticky_hide');
                $('.mc_search_box').removeClass('mc_mobile_search_border_none_bottom');
                $('.mc_search_container').removeClass('mc_mobile_search_border_none');
                $('.mc_mobile_search_input_sticky').removeClass("mc_mobile_search_input_sticky_hide");
                $('.mc_mobile_search').removeClass('mc_mobile_search_border_none');
                $('.mc_search_close_mobile').removeClass("mc_mobile_search_input_sticky_hide");
                $('.new-nav-top-padding-index').removeClass('product-template-nav-margin-index');
                $('.product-template .new-nav-top-padding').removeClass('product-template-nav-margin-product');
                $('.new-nav-top-padding').removeClass('product-template-nav-margin');
                $('.mc_search_field_hamburger').removeClass('mc_mobile_search_input_sticky_hide');
              }
            }

            if (nowScrollTop > lastScrollTop) {
              
              if (screen.width <= 1200) {
                $('.mc_mobile_sticky').addClass('mc_mobile_sticky_hide');
                $('.mc_search_box').addClass('mc_mobile_sticky_hide');
              }
              $('.mc_search_box').addClass('mc_mobile_search_border_none_bottom');
              $('.mc_search_container').addClass('mc_mobile_search_border_none');
              $('.mc_mobile_search_input_sticky').addClass("mc_mobile_search_input_sticky_hide");
              $('.mc_mobile_search').addClass('mc_mobile_search_border_none');
              $('.mc_search_close_mobile').addClass("mc_mobile_search_input_sticky_hide");
              $('.mc_search_field_hamburger').removeClass('mc_mobile_search_input_sticky_hide');

            } else {
             
             
              if (screen.width <= 768) {
            
              }

            }
          }
          lastScrollTop = nowScrollTop;
        }
        //$('#mc_menu').addClass('mc_solid');
        fixed = true;
      }

    } else {

      $('.home-top-carousel').slick(`slickPlay`);
      /*  if (mMediaStickyScroll.matches && $(mc_search_stickyHidden).is(':hidden')) {
         console.log("ELSE NAV 2");
         $('body').removeClass('mc_fixed');
       } else if (mMediaDesktopscroll.matches) {
         console.log("ELSE NAV 3");
         $('body').removeClass('mc_fixed');
       } 
      fixed = false;
    }
    */
  });

  $('.mc_mobile_open button[data-handle]').on('click keypress', function (event) {
    if (realClick(event) === true) {
      if ($(this).hasClass('selected')) {
        resetMobile();
      } else {
        $('.mc_mobile_footer').addClass('active');
        $('.mc_mobile_open button[data-handle]').addClass('mc_hidden');
        $(this).removeClass('mc_hidden').addClass('selected');
        $('.mc_mobile_open div[data-handle="' + $(this).data('handle') + '"]').show();
        var dropdownMenu = document.querySelector('#dropdown-' + $(this).data('handle'));
        bodyScrollLock.disableBodyScroll(dropdownMenu);
      }
    }
  });

  $('.mc_mobile_open button[data-list]').on('click keypress', function (event) {
    //console.log('hit');
    if (realClick(event) === true) {
      if ($(this).hasClass('closed')) {
        $(this).removeClass('closed');
        $(this).next('ul').show();
      } else {
        $(this).addClass('closed');
        $(this).next('ul').hide();
      }
    }
  });

  $('.mc_search_close_mobile').click(function (e) {
    e.preventDefault();

    $('.mc_mobile_sticky').toggleClass('mc_mobile_sticky_hide');
    $('.mc_search_box').toggleClass('mc_mobile_sticky_hide');
    $('.mc_search_box').toggleClass('mc_mobile_search_border_none_bottom');
    $('.mc_search_container').toggleClass('mc_mobile_search_border_none');
    $('#mc_menu').toggleClass('mc_solid');
    $('.mc_mobile_search_input_sticky').toggleClass("mc_mobile_search_input_sticky_hide");
    $('.mc_mobile_search').toggleClass('mc_mobile_search_border_none');
    $('.mc_search_close_mobile').toggleClass("mc_mobile_search_input_sticky_hide");
    $('.new-nav-top-padding').toggleClass('product-template-nav-margin');
    $('.product-template .new-nav-top-padding').toggleClass('product-template-nav-margin-product');
    $('.nav-margin-collections').toggleClass('collections-template-nav-margin');
    $('.new-nav-top-padding-index').toggleClass('product-template-nav-margin-index');
    $('.results_box_mobile').hide();
    $('.results_box_mobile').removeClass('results_box_mobile_height_open');
    $('.results_box_mobile_hamburger').hide();
    $('.results-box .mc_search_all_mobile').hide();
    $('.mc_search_heading_mobile').hide();
    $('.mc_search_all_no_products').remove();
    $('body').removeClass('body-overflowy');
  });

  $('.mc_search_close_mobile_hamburger').click(function (e) {
    e.preventDefault();
    $('.mc_search_all_no_products_hamburger').remove();
    $('.results_box_mobile_hamburger').removeClass('results_box_mobile_height_open');
    $('.results_box_mobile').removeClass('results_box_mobile_height_open');
    $('.results_box_mobile_hamburger').hide();
    $('.results_box_mobile').hide();
    $('.results-box-hamburger .mc_search_all_mobile').hide();
    $('.mc_search_heading_mobile').hide();
  });

  $('.mc_search_close').click(function (e) {
    e.preventDefault();
    $('.mc_list_container[data-handle="search"]').show().data('open', 'false');
    $('#mc_menu[data-index]').removeClass('mc_solid');
    $('.mc_list_top').removeClass('open');
    $('.mc_list_container[data-handle]').hide();
    $('.mc_search_field').blur();
    $('.mc_search_field_hamburger').blur();

  });

  $('.mc_menu_mobile .mc_search').click(function (e) {
    e.preventDefault();
    $('.mc_menu_mobile .mc_hamburger').click();
    $('.mc_mobile_search_input').focus();
  });

  $('.mc_menu_mobile .mc_search_sticky').click(function (e) {
    e.preventDefault();

    $('.mc_mobile_sticky').toggleClass('mc_mobile_sticky_hide');
    $('.mc_search_box').toggleClass('mc_mobile_sticky_hide');
    $('.mc_search_box').toggleClass('mc_mobile_search_border_none_bottom');
    $('.mc_search_container').toggleClass('mc_mobile_search_border_none');
    $('#mc_menu').toggleClass('mc_solid');
    $('.mc_mobile_search_input_sticky').toggleClass("mc_mobile_search_input_sticky_hide");
    $('.mc_mobile_search').toggleClass('mc_mobile_search_border_none');
    $('.mc_search_close_mobile').toggleClass("mc_mobile_search_input_sticky_hide");
    $('.new-nav-top-padding').toggleClass('product-template-nav-margin');
    $('.product-template .new-nav-top-padding').toggleClass('product-template-nav-margin-product');
    $('.nav-margin-collections').toggleClass('collections-template-nav-margin');
    $('.new-nav-top-padding-index').toggleClass('product-template-nav-margin-index');
    $('.results_box_mobile').hide();
    $('.results_box_mobile').removeClass('results_box_mobile_height_open');
    $('.results_box_mobile_hamburger').hide();
    $('.results-box .mc_search_all_mobile').hide();
    $('.mc_search_heading_mobile').hide();
    $('.mc_search_all_no_products').remove();
    $('body').removeClass('body-overflowy');
  });

  $('.mc_mobile_search_input[type="text"]').focus(function () {

    let element = document.querySelector('.results_box_mobile');
    let elementStyle = window.getComputedStyle(element);
    let elementColor = elementStyle.getPropertyValue('display');

    if (elementColor != 'none') {
      if (!$('body').hasClass('mobile_opened')) {
        $('body').addClass('body-overflowy');
      }
    }

    let element2 = document.querySelector('.results_box_mobile_hamburger');
    let elementStyle2 = window.getComputedStyle(element2);
    let elementColor2 = elementStyle2.getPropertyValue('display');

    if (elementColor2 != 'none') {
      if (!$('body').hasClass('mobile_opened')) {
        $('body').addClass('body-overflowy');
      }
    }


  });

  /*   $('.mc_mobile_search_input[type="text"]').click(function (e) {
      e.preventDefault();
      console.log()
      let element = document.querySelector('.results_box_mobile');
      let elementStyle = window.getComputedStyle(element);
      let elementColor = elementStyle.getPropertyValue('display');
      if (elementColor != 'none' && $('.results_box_mobile').is(':empty')) {
        $('body').addClass('body-overflowy');
      }
    }); */

  /***************************************************************

  ALGOLIA SEARCH

  https://GBV3Q8UHM5-dsn.algolia.net/1/indexes/shopify_products/query

  headers + public api key:
  X-Algolia-Application-Id: GBV3Q8UHM5
  X-Algolia-API-Key: 78115b95265a095cafcf99f1aa9069f1

  body:
  {
      "query": "ma-1",
      "hitsPerPage": 25,
      "distinct": 1
  }


  ***************************************************************/

  $('.mc_search_field[type="text"]').bind('focusin focusout', function (e) {


    $(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
    $('.results_box_mobile').addClass('results_box_mobile_height_open');
    let element = document.querySelector('.results_box_mobile');
    let elementStyle = window.getComputedStyle(element);
    let elementColor = elementStyle.getPropertyValue('display');
    if (elementColor != 'none') {

      if (screen.width <= 768) {
        if (!$('body').hasClass('mobile_opened')) {
          $('body').addClass('body-overflowy');
        }
      }
    }

    let element2 = document.querySelector('.results_box_mobile_hamburger');
    let elementStyle2 = window.getComputedStyle(element2);
    let elementColor2 = elementStyle2.getPropertyValue('display');
    if (elementColor2 != 'none') {

      if (screen.width <= 768) {
        if (!$('body').hasClass('mobile_opened')) {
          $('body').addClass('body-overflowy');
        }
      }
    }


    $('.mc_search_heading_mobile').show();

    $('.mc_search_all_mobile').show();
  });

  $('.mc_search_field_hamburger[type="text"]').bind('focusin focusout', function (e) {

    $(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
    let element = document.querySelector('.results_box_mobile');
    let elementStyle = window.getComputedStyle(element);
    let elementColor = elementStyle.getPropertyValue('display');
    if (elementColor != 'none') {

      if (screen.width <= 768) {
        if (!$('body').hasClass('mobile_opened')) {
          $('body').addClass('body-overflowy');
        }
      }
    }

    let element2 = document.querySelector('.results_box_mobile_hamburger');
    let elementStyle2 = window.getComputedStyle(element2);
    let elementColor2 = elementStyle2.getPropertyValue('display');
    if (elementColor2 != 'none') {

      if (screen.width <= 768) {
        if (!$('body').hasClass('mobile_opened')) {
          $('body').addClass('body-overflowy');
        }
      }
    }


    $('.mc_search_heading_mobile_hamburger').show();

    $('.mc_search_all_mobile').show();
  });



  /// Live search
  var preLoadLoadGif = $('<img src="//www.alphaindustries.com/cdn/shop/t/1283/assets/animated_spinner.gif?v=84948565574383479721766417920" />');
  var searchTimeoutThrottle = 500;
  var searchTimeoutID = -1;
  var jqxhr = null;
  var $resultsBox = $('<div class="results-box results_box_mobile" />').appendTo('.mc_search_container');
  var $resultsBoxHamburger = $('<div class="results-box-hamburger results_box_mobile_hamburger" />').appendTo('.mc_search_container');
  //var action = '//services.mybcapps.com/bc-sf-filter/search/suggest';
  var action = `https://GBV3Q8UHM5-dsn.algolia.net/1/indexes/shopify_products/query`;
  $('.mc_search_field[type="text"]').bind('keyup change', function () {

    //Only search if search string longer than 2, and it has changed
    if ($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {
      //Reset previous value
      $(this).data('oldval', $(this).val());

      // Kill outstanding ajax request
      if (jqxhr != null) jqxhr.abort();

      // Kill previous search
      clearTimeout(searchTimeoutID);

      var $form = $(this).closest('form');

      //Search term
      var term = $form.find('input[name="q"]').val();

      //URL for full search page
      // var linkURL = $form.attr('action') + '?type=product&q=' + term; // standard shopify search (non-predictive)
      var linkURL = '/search' + '?q=' + term + '&type=product';

      let searchQuantityProducts;
      if (screen.width > 768) {
        searchQuantityProducts = 5;
      } else {
        searchQuantityProducts = 8;
      }


      //Show loading
      $resultsBox.html('<div class="load"><img src="//www.alphaindustries.com/cdn/shop/t/1283/assets/animated_spinner.gif?v=84948565574383479721766417920" /></div>');
      $('.results-box .mc_search_all').remove();
      $('.mc_search_all_no_products').remove();
      var containerResultsBox = document.querySelector('.results-box');

      $('.results_box_mobile').addClass('results_box_mobile_height');
      $('.results_box_mobile').addClass('results_box_mobile_height_open');
      $('.mc_search_heading').remove();
      if (screen.width <= 768) {
        if (!$('body').hasClass('mobile_opened')) {
          $('body').addClass('body-overflowy');
        }
      }

      // Do next search (in X milliseconds)
      searchTimeoutID = setTimeout(function () {
        //Ajax hit on search page
        //currReqObj = $.ajax({
        //length parameter - this is how many search results will be returned
        jqxhr = $.post({
          url: action,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'X-Algolia-Application-Id': 'GBV3Q8UHM5',
            'X-Algolia-API-Key': '78115b95265a095cafcf99f1aa9069f1'
          },

          data: JSON.stringify(
            {
              query: `'${term}'`,
              "hitsPerPage": 25,
              "distinct": 1,
              "offset": 0,
              "length": searchQuantityProducts,
              "clickAnalytics": true,
              "filters": "inventory_quantity>0"
            }),
          dataType: "json",
          contentType: 'application/json',
          success: function (data) {
            jqxhr = null;
            //console.log(`Search called successfully:`);
            // console.log("data23", data);
            // console.log("colorSumJson[k",)

            if (data.nbHits == 0) {
              //No results
              //console.log(`No results found in search...`);
              $resultsBox.empty();
              $resultsBox.prepend('<div class="mc_search_all mc_search_all_mobile mc_search_all_no_products">NO PRODUCTS FOUND FOR "' + $form.find('input[name="q"]').val() + '" ... </div>');
            } else {
              // console.log(`${data.total_product} results found in search...`);

                  //Numerous results
              $resultsBox.empty();
              var $container = $('<div class="d-productInfo-container"></div>'); // Nuevo contenedor

              $.each(data.hits, function (index, item) {
                  var xshow = 'wholesale'; //term for products we dont want to show
                  if (!(item.title.toLowerCase().indexOf(xshow) > -1)) {
                      var product_page_link = '/products/';
                      var $row = $('<a class="d-productInfo"></a>').attr('href', product_page_link + item.handle);

                      if (screen.width >= 768) {
                          $row.append('<div class="img" style="position:relative"><img class="search_d_imgheight_mobile" src="' + item.product_image.replace(".jpg", "_360x360.jpg") + '" alt="' + 'alt text' + '" + />' + `${item.named_tags.badge ? "<div class='product-v2--tag--collections-search' style='display: block;bottom: 16px !important'>" + `${item.named_tags.badge}` + "</div>" : ''}` + '</div>');
                      }

                      $row.append('<div class="d-title">' + item.title + '</div>');

                      if (screen.width >= 768) {
                          if (item.compare_at_price != 0) {
                              $row.append('<div class="d-comparePrice">' + `${formatMoney(Number(item.compare_at_price) * 100)}` + '</div>');
                          }
                          $row.append('<div class="d-price">' + `${formatMoney(Number(item.price) * 100)}` + '</div>');
                      }

                      $container.append($row);
                  }
              });

              $resultsBox.append($container);
              $resultsBox.prepend('<div class="mc_search_heading mc_search_heading_mobile">SHOWING RESULTS FOR <b>"' + $form.find('input[name="q"]').val() + '"</b></div>');
              $resultsBox.append('<a href="' + linkURL + '" class="mc_search_all mc_search_all_mobile">VIEW ALL SEARCH RESULTS</a>');

            }
          }

        })
          .done(function () {
            //console.log(`done searching for: ${term}`);
          })
          .fail(function (e) {
            // console.log(`error searching for: ${term}; ${JSON.stringify(e)}`);
          })
          .always(function () {
            //console.log(`always searching for: ${term}`);
          });
      }, searchTimeoutThrottle);
    } else if ($(this).val().length <= 2) {
      //Deleted text? Clear results

      $('.results_box_mobile').removeClass('results_box_mobile_height_open');
      $('.results-box').removeClass('results_box_mobile_height');
      $resultsBox.empty();
    }
  }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function () {
    //Focus, show results
    $resultsBox.fadeIn(200);
  }).bind('click', function (e) {
    //Click, prevent body from receiving click event
    e.stopPropagation();
  });

  $('.mc_search_field_hamburger[type="text"]').bind('keyup change', function () {

    //Only search if search string longer than 2, and it has changed
    if ($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {
      //Reset previous value
      $(this).data('oldval', $(this).val());

      // Kill outstanding ajax request
      if (jqxhr != null) jqxhr.abort();

      // Kill previous search
      clearTimeout(searchTimeoutID);

      var $form = $(this).closest('form');

      //Search term
      var term = $form.find('input[name="q"]').val();

      //URL for full search page
      // var linkURL = $form.attr('action') + '?type=product&q=' + term; // standard shopify search (non-predictive)
      var linkURL = '/search' + '?q=' + term + '&type=product';

      let searchQuantityProducts;
      if (screen.width > 768) {
        searchQuantityProducts = 5;
      } else {
        searchQuantityProducts = 8;
      }


      //Show loading
      $resultsBoxHamburger.html('<div class="load"><img src="//www.alphaindustries.com/cdn/shop/t/1283/assets/animated_spinner.gif?v=84948565574383479721766417920" /></div>');
      $('.results-box-hamburger .mc_search_all').remove();
      $('.mc_search_all_no_products_hamburger').remove();
      var containerResultsBox = document.querySelector('.results-box');

      $('.results_box_mobile_hamburger').addClass('results_box_mobile_height');
      $('.results_box_mobile_hamburger').addClass('results_box_mobile_height_open');
      $('.mc_search_heading_hamburger').remove();
      if (screen.width <= 768) {
        if (!$('body').hasClass('mobile_opened')) {
          $('body').addClass('body-overflowy');
        }
      }


      // Do next search (in X milliseconds)
      searchTimeoutID = setTimeout(function () {
        //Ajax hit on search page
        //currReqObj = $.ajax({
        //length parameter - this is how many search results will be returned
        jqxhr = $.post({
          url: action,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'X-Algolia-Application-Id': 'GBV3Q8UHM5',
            'X-Algolia-API-Key': '78115b95265a095cafcf99f1aa9069f1'
          },

          data: JSON.stringify(
            {
              query: `'${term}'`,
              "hitsPerPage": 25,
              "distinct": 1,
              "offset": 0,
              "length": searchQuantityProducts,
              "clickAnalytics": true,
              "filters": "inventory_quantity>0"
            }),
          dataType: "json",
          contentType: 'application/json',
          success: function (data) {
            jqxhr = null;
            //console.log(`Search called successfully:`);
            // console.log("data23", data);
            // console.log("colorSumJson[k",)

            if (data.nbHits == 0) {
              //No results
              //console.log(`No results found in search...`);
              $resultsBoxHamburger.empty();
              $resultsBoxHamburger.prepend('<div class="mc_search_all mc_search_all_mobile mc_search_all_no_products_hamburger">NO PRODUCTS FOUND FOR "' + $form.find('input[name="q"]').val() + '" ... </div>');
            } else {
              // console.log(`${data.total_product} results found in search...`);

              //Numerous results
              $resultsBoxHamburger.empty();
              $.each(data.hits, function (index, item) {
                // console.log("options_with_values", item);
                var xshow = 'wholesale'; //term for products we dont want to show
                if (!(item.title.toLowerCase().indexOf(xshow) > -1)) {
                  /*     var jqxhr1 = null;
                      var action = `https://erhs1q9h1b.execute-api.us-east-1.amazonaws.com/products?product_handle=${item.handle}&action=colors_by_product_handle`;
                      if (jqxhr1 != null) jqxhr1.abort();
                      var selector = 'variants-' + item.handle; */
                  // console.log(`search item: ${JSON.stringify(item)}`);
                  // console.log(`search item 2: ${item}`);
                  // console.log('item.handle', item.handle);
                  var product_page_link = '/products/'
                  var $row = $('<a></a>').attr('href', product_page_link + item.handle);
                  if (screen.width >= 768) {
                    $row.append('<div class="img" style="position:relative"><img class="search_d_imgheight_mobile" src="' + item.product_image.replace(".jpg", "_360x360.jpg") + '" alt="' + 'alt text' + '" + />' + `${item.named_tags.badge ? "<div class='product-v2--tag--collections' style='display: block;bottom: 16px !important'>" + `${item.named_tags.badge}` + "</div>" : ''}` + '</div>');
                  }
                  $row.append('<div class="d-title">' + item.title + '</div>');
                  if (screen.width >= 768) {
                    $row.append('<div class="d-price">' + `${formatMoney(Number(item.price) * 100)}` + '</div>');
                  }
                  /*  jqxhr1 = $.post({
                     url: action,
                     method: 'GET',
                     success: function (data) {
                       jqxhr1 = null;
                       console.log(`colors by handle: ${JSON.stringify(data)}`);
                       console.log(`selector: ${selector}`);
                       var variant_txt = ''
                       data.forEach(function (item, index) {
                         $row.append('<a href="//alphaindustries.com/products/' + `${item.handle}` + '?variant=' + `${item.variant_id}` + '"><img src="https://cdn.shopify.com/s/files/1/2513/7040/files/swatch-' + `${item.color_name.toLowerCase().replaceAll(" ", "-").replaceAll("/", "-")}` + '.jpg" style="margin-left: 1px; margin-right: 1px; width: 15px; border-radius: 15px; border: 1px solid #bbbbbb;" alt="${item.color_name}"></a>');
                       });
                       $('.' + selector).html(variant_txt);
                     }
                   }) */

                  $resultsBoxHamburger.append($row);
                }
              });
              $resultsBoxHamburger.prepend('<div class="mc_search_heading_hamburger mc_search_heading_mobile_hamburger">SHOWING RESULTS FOR <b>"' + $form.find('input[name="q"]').val() + '"</b></div>');
              $resultsBoxHamburger.append('<a href="' + linkURL + '" class="mc_search_all mc_search_all_mobile">VIEW ALL SEARCH RESULTS</a>');
            }
          }

        })
          .done(function () {
            //console.log(`done searching for: ${term}`);
          })
          .fail(function (e) {
            // console.log(`error searching for: ${term}; ${JSON.stringify(e)}`);
          })
          .always(function () {
            //console.log(`always searching for: ${term}`);
          });
      }, searchTimeoutThrottle);
    } else if ($(this).val().length <= 2) {
      //Deleted text? Clear results


      $('.results-box-hamburger').removeClass('results_box_mobile_height');
      $resultsBoxHamburger.empty();
    }
  }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function () {
    //Focus, show results
    $resultsBoxHamburger.fadeIn(200);
  }).bind('click', function (e) {
    //Click, prevent body from receiving click event
    e.stopPropagation();
  });

  $('body').bind('click', function () {
    //Click anywhere on page, hide results
    //$resultsBox.fadeOut(200);
  });

  //Search box should mimic live search string: products only, partial match
  $('.search-form').on('submit', function (e) {
    e.preventDefault();
    var term = $(this).find('input[name="q"]').val();
    var linkURL = '/search' + '?q=' + term + '&type=product';
    window.location = linkURL;
  });

  // search ends

});

//Function to allow buttons to be ADA friendly and trigger on 'Enter' keypress
function realClick(event) {
  if (event.type === 'click') {
    return true;
  }
  else if (event.type === 'keypress') {
    var code = event.charCode || event.keyCode;
    if ((code === 32) || (code === 13)) {
      return true;
    }
  }
  else {
    return false;
  }
}

function resetMobile() {
  $('.mc_mobile_open button[data-handle]').removeClass('mc_hidden').removeClass('selected');
  $('.mc_mobile_open div[data-handle]').hide();
  $('.mc_mobile_open .mc_list_header').removeClass('closed');
  $('.mc_mobile_open .mc_list_links').show();
  $('.mc_mobile_footer').removeClass('active');
}


